import { useSelector, useDispatch } from "react-redux";
import { selectSpecsLabel, selectSpecsURL, selectSpecsJumpLink, openSpecsOrdering, selectSpecsLabelIcon } from "../store/orderingSlice";

export function SpecsLink () {
    const dispatch = useDispatch();
    const specs_url = useSelector(selectSpecsURL);
    const specs_jump_link = useSelector(selectSpecsJumpLink);
    const specs_label = useSelector(selectSpecsLabel);
    const specs_label_icon = useSelector(selectSpecsLabelIcon);

    const handleSpecsLinkClick = (e) => {
        e.preventDefault()
        if (specs_jump_link) {
            const scrollToElement = document.querySelector(specs_jump_link);
            const scrollBehavior = window.matchMedia('(prefers-reduced-motion: no-preference)').matches ? 'smooth' : 'instant';
            if (scrollToElement) {
                scrollToElement.setAttribute('tabindex', '-1');
                scrollToElement.addEventListener('blur', function() {
                    this.removeAttribute("tabindex");
                })
                scrollToElement.scrollIntoView({block: 'center', behavior: scrollBehavior, container: 'nearest'})
                scrollToElement.focus({preventScroll: true})
            }
        } else {
            dispatch(openSpecsOrdering());
        }
    }

    return specs_url && (
        <a
            className='product-specs-link pb-4 valid-link d-flex align-items-center'
            aria-label='Product Specs'
            title='Product Specs'
            href={specs_jump_link ? specs_jump_link : specs_url}
            onClick={handleSpecsLinkClick}
        >
            {specs_label_icon && <span class={`icon ${specs_label_icon} mr-1`}></span>}
            {specs_label}
        </a>
    );
}